import React from "react";
import type { Equipment } from "../../../api/equipment/Equipment.typed";

export function useEquipmentSelection(equipments: Equipment[]) {
  const [selectedIds, setSelectedIds] = React.useState<string[]>([]);

  const toggleSelect = React.useCallback((id: string) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]));
  }, []);

  const toggleSelectAll = React.useCallback(() => {
    const allIds = (equipments || []).filter((e) => e.ID).map((e) => e.ID!) as string[];
    setSelectedIds((prev) => (prev.length === allIds.length ? [] : allIds));
  }, [equipments]);

  const removeFromSelection = React.useCallback((id: string) => {
    setSelectedIds((prev) => prev.filter((p) => p !== id));
  }, []);

  const clearSelection = React.useCallback(() => setSelectedIds([]), []);

  return { selectedIds, toggleSelect, toggleSelectAll, removeFromSelection, clearSelection };
}
